import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkUnlinkLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M17 22v-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 15l6 -6" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" }),
		/* @__PURE__ */ _jsx("path", { d: "M20 17h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 7h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 2v2" })
	]
});
export default SvgLinkUnlinkLine;
